import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { CurrentTimezoneModel } from '../models/current-timezone.model';
import { CurrentMeetService } from '../services/current-meet.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-timezone-toggle',
  imports: [AsyncPipe],
  templateUrl: './timezone-toggle.component.html',
  styleUrl: './timezone-toggle.component.scss',
})
export class TimezoneToggleComponent {
  currentTimezone$!: Observable<CurrentTimezoneModel | null>;
  constructor(private currentMeetService: CurrentMeetService) {}

  ngOnInit() {
    this.currentTimezone$ = this.currentMeetService.updateCurrentTimezone;
  }

  setCurrentTimezone(techieOffset: string) {
    this.currentMeetService.setCurrentTimezone(techieOffset);
  }
}
